import React, { useId } from "react";

const Passthrough = ({ children }) => <>{children}</>;

const RadioOption = ({
  instanceId,
  name,
  value,
  defaultValue,
  label,
  index,
  ItemWrapper = Passthrough,
  wrapperProps = {},
  radioClassName = 'radio-col-red',
  onChange,
}) => (
  <ItemWrapper {...{name, value}} {...wrapperProps}>
    <input
      name={name}
      value={value}
      type="radio"
      id={`${instanceId}-${name}-${index}`}
      className={`with-gap ${radioClassName}`}
      checked={value === defaultValue}
      onChange={onChange}
    />
    <label htmlFor={`${instanceId}-${name}-${index}`}>{label}</label>
  </ItemWrapper>
);
const doesNothing = () => {};

const Radio = ({
  defaultValue = null,
  name="",
  options = [],
  itemWrapper: ItemWrapper,
  onChange=doesNothing,
  wrapperProps={},
}) => {
  const instanceId = useId();

  return (
    <>
      {options.map((option, index) => (
        <RadioOption
          {...option}
          instanceId={instanceId}
          ItemWrapper={ItemWrapper}
          wrapperProps={wrapperProps}
          name={name}
          index={index}
          defaultValue={defaultValue}
          key={option.value}
          onChange={onChange}
          radioClassName={option.radioClassName}
        />
      ))}
    </>
  );
};

export default Radio;
